export const environment = {
  production: true,
  socketIO: {
  	url: 'http://localhost:5000',
  	timeout: 5000
  }
};